import React, { } from 'react';
import DetectDevice from './DeviceDetector';
import { BsInstagram, BsTwitter } from 'react-icons/bs';

export const Info_about = () => {
      return (
      <>
            <span>
              <h5>About</h5>
            </span>
            <div className="info-line-container">
              <span className="info-line"></span>
            </div>

            <p>
              This project was created by{' '}
              <a href="http://salavon.com/" rel="noreferrer" target="_blank">
                Jason Salavon
              </a>{' '}
              and Co. under the banner of{' '}
              <a
                href="https://latentculture.com/"
                rel="noreferrer"
                target="_blank"
              >
                Latent Culture
              </a>
              , an AI research & production venture based within Jason Salavon
              Studio. Established in 2017, we are artists, programmers, and
              researchers investigating how deep learning and other generative
              systems can impact creative production.
              <br></br>
              <br></br>
              Jason Salavon has created and exhibited data-driven generative
              artwork since the 1990s. His work is included in prominent
              collections including the Museum of Modern Art, Metropolitan
              Museum of Art, the Whitney Museum of Art, the Los Angeles County
              Museum of Art, and the Art Institute of Chicago, among many
              others. Salavon has shown artwork around the
              world and been featured in publications such as The New York
              Times, Artforum, Art in America, and WIRED. He is currently
              associate professor in the Department of Visual Arts at the
              University of Chicago.
            </p>
            <br></br>
            <br></br>


            <span>
        <h5>Contact</h5>
      </span>
      <div className="info-line-container">
        <span className="info-line"></span>
      </div>
      Please reach out to us at{' '}
      <a href="mailto:todem@latentculture.com" rel="noreferrer" target="_blank">
        todem@latentculture.com
      </a>{' '}
      with any inquiries.
      <br></br><br></br>
      <BsTwitter
        className="icon"
        onClick={() =>
          (window.location.href = 'https://twitter.com/latentculture')
        }
        style={{
          cursor: 'pointer',
          pointerEvents: 'all',
          color: 'white',
          pointer: 'cursor',
          fontSize: DetectDevice ? 35 : 35,
        }}
      />
      <BsInstagram
        className="icon"
        onClick={() =>
          (window.location.href =
            'https://www.instagram.com/jasonsalavonstudio/')
        }
        style={{
          marginLeft: '20px',
          pointerEvents: 'all',
          pointer: 'cursor',
          color: 'white',
          fontSize: DetectDevice ? 35 : 35,
        }}
      />
      <br></br><br></br>
            <span>
              <h5>Team</h5>
            </span>
            <div className="info-line-container">
              <span className="info-line"></span>
            </div>

            <h6>
              <span style={{ color: '#bebebe' }}>Jason Salavon</span>
            </h6>
            <span className="info-position-name">
              Artist, Creative & Technical Lead
            </span>
            <br></br>
            <br></br>

            <h6>
              <span style={{ color: '#bebebe' }}>Lewis Arnsten</span>
            </h6>
            <span className="info-position-name">
              Lead Developer, Rendering & Blockchain
            </span>
            <br></br>
            <br></br>

            <h6>
              <span style={{ color: '#bebebe' }}>Owen Fahey</span>
            </h6>
            <span className="info-position-name">
              Lead Developer, Full Stack
            </span>
            <br></br>
            <br></br>
            <h6>
              <span style={{ color: '#bebebe' }}>Mac Rescorl</span>
            </h6>
            <span className="info-position-name">
              Media Production
            </span>
            <br></br>
            <br></br>
            <h5b>Contributors</h5b>
            <div className="info-line-container">
              <span className="info-line"></span>
            </div>
            <h6>
              <span style={{ color: '#bebebe' }}>Miles MacClure, Guhn Lee, Kiki Apple, Elizabeth Li</span>
            </h6>
            <br></br>&nbsp;
            <br></br>&nbsp;
            <br></br>
      {DetectDevice ? (
        <span>
          {' '}
          <a href="https://www.latentculture.com/todem/TODEM-License_Agreement.pdf">
            {' '}
            &emsp; &emsp; &emsp; NFT License Agreement{' '}
          </a>{' '}
        </span>
      ) : null}

      </>
)}

export default Info_about;